<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<span epub:type="pagebreak" id="pg_vii" title="vii">
<p class="DED"><span class="ePub-I">for my parents</span></p>
<p class="DED"><span class="ePub-I">who deserve so much more than a book</span></p>
<p class="DED"><span class="ePub-I">here’s a book</span></p>
</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1cbc4c66